import { useEffect, useMemo, useState } from "react"
import { useFilter } from "../../../context/FIlterContext";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import _ from "underscore";

export const useTaskStatusTrendSummary = () => {
    const { projectFilter, setProjectFilter } = useFilter();
    const [taskStatusTrendData, setTaskStatusTrendData] = useState([]);
    const [filterData, setFilterData] = useState({
        type: "monthly",
    });
    const [loader, setLoader] = useState(false);
    const dropdownOption = [
        { name: "Weekly", value: "weekly" },
        { name: "Monthly", value: "monthly" },
        { name: "yearly", value: "yearly" },
    ]

    useEffect(() => {
        if (projectFilter?.apiCall) {
            getTaskStatusTrendSummary();
        }
    }, [projectFilter?.apiCall]);


    const getTaskStatusTrendSummary = async () => {
        try {
            setLoader(true)
            const payload = {
                "client_id": projectFilter?.client_id?.client_id || 0,
                "project_ids": _.pluck(projectFilter?.project_ids, 'project_id')?.toString(),
                "lead_user_code": projectFilter?.lead_user_code?.user_code || 0,
                "request_user_code": projectFilter?.request_user_code || 0,
                "project_module_ids": _.pluck(projectFilter?.project_module_ids, 'option_id')?.toString(),
                "feature_ids": _.pluck(projectFilter.feature_ids, 'issue_id')?.toString(),
                "issue_key": projectFilter?.issue_id,
                "category_key": filterData?.type,
                "from_date": filterData?.hoveredRange?.[0]?.toDate()?.toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-") || "",
                "to_date": filterData?.hoveredRange?.[1]?.toDate()?.toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-") || ""
            }
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTTASKSTATUSTRENDSUMMARY'), payload)
            if (res?.status === 200) {
                let data = res?.body?.data?.project_task_status_trend_summary;
                data = data.filter(item => (item.done_tasks > 0 || item.created_tasks > 0));
                if (data.length === 0) {
                    setTaskStatusTrendData([]);
                } else {
                    const categories = data.map(item => item.category_name);
                    const doneTasksData = data.map(item => item.done_tasks);
                    const createdTasksData = data.map(item => item.created_tasks);

                    const min = Math.min(...doneTasksData, ...createdTasksData);
                    const max = Math.max(...doneTasksData, ...createdTasksData);
                                   const tickInterval = Math.ceil(((max - min) / 4));
                    setTaskStatusTrendData({
                        data: [
                            { name: 'Done Tasks', data: doneTasksData },
                            { name: 'Created Tasks', data: createdTasksData }
                        ], xAxis: categories, min, max, tickInterval
                    });
                }
            }
            setFilterData((prev) => ({ ...prev, isChange: false }))
            setLoader(false)
        } catch (error) {
            setLoader(false)
            setProjectFilter((prev) => ({ ...prev, apiCall: false }))
            console.error('Error :', error);
        }
    }

    return useMemo(() => ({
        taskStatusTrendData, loader, dropdownOption, filterData, setFilterData, getTaskStatusTrendSummary
    }), [taskStatusTrendData, loader, dropdownOption, filterData, setFilterData, getTaskStatusTrendSummary]);
}